import React from 'react';
import '../../styles/Loading.css';

interface LoadingProps {
    message?: string;
    compact?: boolean;
}

const Loading: React.FC<LoadingProps> = ({ 
    message = "Loading...", 
    compact = false 
}) => {
    return (
        <div className={`loading-screen ${compact ? 'loading-compact' : ''}`}>
            <div className="spinner"></div>
            {message && <p className="loading-message">{message}</p>}
        </div>
    );
};

export default Loading;